(function () {
  var MAX_FILES = 5;

  function byId(id) {
    return document.getElementById(id);
  }

  function setStatus(message, isError) {
    var el = byId('DamageClaimForm-status');
    if (!el) return;
    el.textContent = message;
    el.classList.remove('visually-hidden', 'form__message', 'damage-claim__status--error');
    el.classList.add('form__message');
    if (isError) el.classList.add('damage-claim__status--error');
  }

  function clearStatus() {
    var el = byId('DamageClaimForm-status');
    if (!el) return;
    el.textContent = '';
    el.classList.add('visually-hidden');
  }

  function renderFileList(input) {
    var list = byId('DamageClaimForm-file-list');
    if (!list || !input) return;
    list.innerHTML = '';
    var files = Array.prototype.slice.call(input.files || []);
    if (!files.length) {
      list.hidden = true;
      return;
    }
    files.forEach(function (file, index) {
      var item = document.createElement('li');
      item.textContent = (index + 1) + '. ' + file.name;
      list.appendChild(item);
    });
    list.hidden = false;
  }

  function buildBody() {
    var order = (byId('DamageClaimForm-order_number') || {}).value || '';
    var material = (byId('DamageClaimForm-print_material') || {}).value || '';
    var description = (byId('DamageClaimForm-description') || {}).value || '';
    var photos = byId('DamageClaimForm-photos');
    var photoCount = photos && photos.files ? photos.files.length : 0;

    return [
      'Damage claim submitted from refund policy page.',
      'Print material: ' + material,
      'Order number: ' + order,
      'Description: ' + description,
      'Photos attached: ' + photoCount
    ].join('\n');
  }

  function sendToMakeWithPhotos(payload, files) {
    if (!window.__makeWebhookUrl) return Promise.resolve();

    var formData = new FormData();
    Object.keys(payload).forEach(function (key) {
      formData.append(key, payload[key]);
    });
    for (var i = 0; i < files.length; i++) {
      formData.append('photo_' + (i + 1), files[i], files[i].name);
    }

    var headers = {};
    if (window.__makeWebhookSecret) {
      headers['X-Webhook-Secret'] = window.__makeWebhookSecret;
    }

    return fetch(window.__makeWebhookUrl, {
      method: 'POST',
      headers: headers,
      body: formData,
      credentials: 'omit'
    }).catch(function () {});
  }

  function submitShopifyContact(form, bodyValue) {
    var bodyField = byId('DamageClaimForm-body');
    if (bodyField) bodyField.value = bodyValue;

    var formData = new FormData(form);
    return fetch(form.action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    });
  }

  function init() {
    var form = byId('DamageClaimForm');
    var photoInput = byId('DamageClaimForm-photos');
    if (!form || !photoInput) return;

    photoInput.addEventListener('change', function () {
      if (photoInput.files.length > MAX_FILES) {
        setStatus('Please select no more than ' + MAX_FILES + ' photos.', true);
        photoInput.value = '';
        renderFileList(photoInput);
        return;
      }
      clearStatus();
      renderFileList(photoInput);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearStatus();

      var files = Array.prototype.slice.call(photoInput.files || []);
      if (files.length > MAX_FILES) {
        setStatus('Please select no more than ' + MAX_FILES + ' photos.', true);
        return;
      }

      var material = (byId('DamageClaimForm-print_material') || {}).value || '';
      if (material === 'Metal' && files.length > 0 && files.length < 3) {
        setStatus('Metal claims should include at least 3 photos showing print and packaging damage.', true);
        return;
      }

      var submitButton = byId('DamageClaimForm-submit');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting…';
      }

      var bodyValue = buildBody();
      var now = new Date().toISOString();
      var payload = {
        form_type: 'damage-claim',
        create_date: now,
        last_update: now,
        first_name: (byId('DamageClaimForm-first_name') || {}).value || '',
        last_name: (byId('DamageClaimForm-last_name') || {}).value || '',
        email: (byId('DamageClaimForm-email') || {}).value || '',
        notes: bodyValue,
        source: 'damage-claim',
        product_title: material,
        tags: 'damage-claim'
      };

      var makePromise = files.length
        ? sendToMakeWithPhotos(payload, files)
        : (window.sendToMake ? window.sendToMake(payload) : Promise.resolve());

      makePromise
        .then(function () {
          return submitShopifyContact(form, bodyValue);
        })
        .then(function () {
          form.reset();
          renderFileList(photoInput);
          setStatus('Thank you. Your damage claim has been submitted. We will review it and respond within 2 business days.', false);
        })
        .catch(function () {
          setStatus('Something went wrong. Please email westbrookcreativellc@gmail.com with your order number and photos.', true);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Submit damage claim';
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
